
@if(isDataLoading){
<div class="example-loading-shade">
    <mat-spinner></mat-spinner>
</div>
}
@if(showFilter){
<div class="col-lg-12 nopadding">
    <app-filter-panel [GridColumns]="gridColumns" [DefaultFilterArray]="DefaultFilterArray"
        [ResetLabel]="isFilterLabelReset" (FilterEvent)="FilterApplyFilterEvent($event)" [isAddFilter]=false>
    </app-filter-panel>
</div>
}
@if(staticFilter){
<div>
    <mat-accordion #accordion="matAccordion" [multi]="true">
        <!--Filter Code  -->
        <mat-expansion-panel [expanded]="true">
            <mat-panel-description>
                <div class="col-lg-12 nopadding">
                    <mat-chip-listbox aria-label="filter" class="col-lg-12 nopadding">
                        <span>
                            <label for="filter">
                                <em class="fa fa-filter" id="cais-audit-trail-filter"></em>
                            </label>
                            @if(reportDate){
                            <mat-chip selected color="green" matTooltip="Date"
                                [matTooltipShowDelay]="1000" matTooltipPosition="after" id="cais-audit-trail-date">
                                Report Date: {{reportDate}}
                            </mat-chip>
                            }
                            @if(receivedFDID){
                            <mat-chip selected color="green"
                                matTooltip="In Customer Record ID" [matTooltipShowDelay]="1000"
                                matTooltipPosition="after" id="cais-audit-trail-receivedFDID">
                                ReceivedFDID: {{receivedFDID}}
                            </mat-chip>
                            }
                            @if(accountNumber){
                            <mat-chip selected color="green"
                                matTooltip="In Customer Record ID" [matTooltipShowDelay]="1000"
                                matTooltipPosition="after" id="cais-audit-trail-accountNumber">
                                AccountNumber: {{accountNumber}}
                            </mat-chip>
                            }
                            @if(inCustomerRecordID){
                            <mat-chip selected color="green"
                                matTooltip="In Customer Record ID" [matTooltipShowDelay]="1000"
                                matTooltipPosition="after" id="cais-audit-trail-inCustomerRecordID">
                                In Customer RecordID: {{inCustomerRecordID}}
                            </mat-chip>
                            }
                            @if(customerRecordID){
                            <mat-chip selected color="green" matTooltip="Customer Record ID"
                                [matTooltipShowDelay]="1000" matTooltipPosition="after"
                                id="cais-audit-trail-customerRecordID">
                                Customer RecordID: {{customerRecordID}}
                            </mat-chip>
                            }
                        </span>
                    </mat-chip-listbox>
                </div>
            </mat-panel-description>
        </mat-expansion-panel>
    </mat-accordion>
</div>
}
<div class="ui-grid-col-12">
    <p-table #dt [value]="CAISAuditData" [columns]="cols" [resizableColumns]="true" columnResizeMode="expand"
        [sortOrder]="constantService.DEFAULT_SORDORDER_ASC" [(selection)]="selectedRows" [paginator]="true"
        selectionMode="single" appendTo="body" alwaysShowPaginator="true" paginatorPosition="both"
        showCurrentPageReport="true" [rows]="constantService.DEFAULT_ROWSIZE" [totalRecords]="CAISAuditData.length > 0 ? CAISAuditData.length : 1"
        [pageLinks]="constantService.GRID_DEFAULT_PAGELINKS" sortMode="multiple"
        [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION" [lazy]="false" [scrollable]="true" 
        scrollHeight="70vh" styleClass="tableData">
        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td [attr.colspan]="columns.length">
                    {{constantService.NO_RECORDFOUND_MSG}}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
                <th [id]="col.field" pResizableColumn [pSortableColumn]="col.field"
                    [ngClass]="{'notdisplay':((col?.display | lowercase) === 'false')}">
                    {{col.header}}
                    @if((col.header | lowercase) !== 'action'){
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                    }
                </th>
                }
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
            <tr [pSelectableRow]="row" [pSelectableRowIndex]="ri">
                @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
                <td class="ui-resizable-column"
                    [ngClass]="{'center':(col.header==='Action'), 'notdisplay':((col?.display | lowercase) === 'false')}">

                    <!-- set String -->
                     @if((col.header!=='Action') && (col.datatype | lowercase) =='string' || (col.datatype | lowercase) =='char'){
                    <span>
                        {{row[col.field]}}
                    </span>
                    }
                    <!-- set JSON -->
                     @if((col.datatype | lowercase) =='json'){
                    <span>
                        {{row[col.field]}}
                    </span>
                    }
                    <!-- set int  -->
                     @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float'){
                    <span style="float:right;">
                        {{row[col.field] * 1}}
                    </span>
                    }
                    @if(col.header === 'Action'){
                    <span>
                        <p-button matTooltip="View Diff" [matTooltipShowDelay]="1000" matTooltipPosition="above"
                            appendTo="body" icon="fa fa-fw fa-code" [id]="'cais-audit-trail-diff'+ rowIndex"
                            class="btnAction"
                            (click)="onJsonViewer(row)">
                        </p-button>
                    </span>
                    }
                </td>
                }
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft">
            Total Records: {{ CAISAuditData?.length == 0 ? 0 : CAISAuditData?.length }}
        </ng-template>
        <ng-template pTemplate="paginatorright">
            <button type="button" matTooltip="Export" [matTooltipShowDelay]="1000" id="export-cais-audit-trail"
                label="export-cais-audit-trail" class="exportBtn" (click)="exportToCSV()"> Export <i
                    class="fa fa-download" aria-hidden="true"></i>
            </button>
        </ng-template>
    </p-table>
    <div>
        @if(isJsonViewer){
        <app-json-viewer-dialog id="cais-audit-trail-json-viewer" (closeEventDialog)="isJsonViewer = false;"
            [selectedJSONObject]="updatedJSONObject" [originalJSONObject]="originalJSONObject"
            [isJSONViewerOpen]="isJsonViewer">
        </app-json-viewer-dialog>
        }
    </div>

</div>